import React, { useState, useContext } from "react";
import { FaTimes } from "react-icons/fa";
import { ImSpinner2 } from "react-icons/im";
import { useFormik } from "formik";

import TailoringContext from "../../context/TailoringContext";
import { BiImageAdd } from "react-icons/bi";

import styles from "../../Styles/Checkout.module.css";
// import useLaundry from "../../hooks/useLaundry";

const Checkout = ({ laundryNewOrder, setcheckoutModal }) => {
  const [img, setImg] = useState();

  const { loader } = useContext(TailoringContext);
  const redirect_url = "https://2mseamless-admin.vercel.app/laundry";

  // const order_id = laundryNewOrder?.laundry_id?.InsertedID;

  // const { handleLaundryCheckout } = useLaundry();

  const uploadImageHandler = (e) => {
    if (!e.target.files) return;
    setImg(e.target.files[0]);
    console.log(e.target.files[0]);
  };

  let formData = new FormData();
  formData.append("image", img);
  formData.append("redirect_url", redirect_url);
  console.log(img);

  const formik = useFormik({
    initialValues: {
      image: "",
    },
    onSubmit(values) {
      // handleLaundryCheckout(order_id, redirect_url, formData).then(() => {
      //   setOpenCheckout(false);
      //   setOrderSuccessful(true);
      // });
      console.log(formData);

      console.log(values);
    },
  });

  return (
    <div className={styles.checkoutContainer}>
      <div className={styles.checkoutChild}>
        <div className="">
          <div className="w-4/5 mx-auto">
            <div className={`text-center ${styles.title}`}>
              <h2 className="text-3xl font-medium mb-1">Upload Image</h2>
              <p className="text-[#171308] text-base"></p>
            </div>
            <form onSubmit={formik.handleSubmit}>
              <div className={styles.inputField}>
                <input
                  onChange={(e) => {
                    uploadImageHandler(e);
                    formik.handleChange(e);
                  }}
                  type="file"
                  name="image"
                  value={formik.values.image}
                  className={styles.input}
                />
                <div className={styles.icon}>
                  <BiImageAdd size={30} color="#BC9A43" />
                </div>
                <p className="mt-3">{img?.name ? img?.name : "Upload Image"}</p>
              </div>
              <button
                disabled={loader}
                className={styles.btn}
              >
                {loader ? (
                  <ImSpinner2 className="spin" size={20} />
                ) : (
                  <span>Proceed to checkout</span>
                )}
              </button>
            </form>
          </div>
          <div className={styles.cancel} onClick={() => setcheckoutModal(false)}>
            <FaTimes size={25} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Checkout;
